const courseSettings = {
  language: "fi",
  name: "Ohjelmoinnin perusteet ja jatkokurssi 2026",
  siteUrl: "https://ohjelmointi-26.mooc.fi",
  githubUrl: "https://github.com/rage/ohjelmointi-26",
  subtitle: "Johdatus ohjelmointiin Python-kielellä",
  slug: "ohjelmointi-2026",
  organizationName: "MOOC",
  tmcCourse: "ohjelmointi-2026",
  quizzesId: "60f292e4-8a27-4230-b281-cd9713bb43be",
  tmcOrganization: "mooc",
  bannerPath: "banner.svg",
  showExerciseDescriptionWhenNotLoggedIn: true,
  courseVariants: [
    {
      tmcOrganization: "jedu",
      tmcCourse: "python-2026-jedu"
    },
    {
      tmcOrganization: "e10129575",
      tmcCourse: "python-2026"
    },
    {
      tmcOrganization: "e10129575",
      tmcCourse: "python-2026-TKAtivi26oa"
    },
    {
      tmcOrganization: "uwasa",
      tmcCourse: "python-2026"
    },
    {
      tmcOrganization: "laurea",
      tmcCourse: "python-2026-ahonen"
    },
    // {
    //   tmcOrganization: "centria",
    //   tmcCourse: "centria-python-2025"
    // },
    // {
    //   tmcOrganization: "graninlukio",
    //   tmcCourse: "grani-tvt4-python-2025"
    // },
    // {
    //   tmcOrganization: "kinnulanlukio",
    //   tmcCourse: "kinnulanlukio-python-ohjelmointi-2025"
    // },
    // {
    //   tmcOrganization: "laurea",
    //   tmcCourse: "python-2025"
    // },
    // {
    //   tmcOrganization: "laurea",
    //   tmcCourse: "laurea-python-henttonen-2025"
    // },
    // {
    //   tmcOrganization: "laurea",
    //   tmcCourse: "python-2025-laurea-stenberg"
    // },
    // {
    //   tmcOrganization: "nissniku",
    //   tmcCourse: "python-2025"
    // },
    // {
    //   tmcOrganization: "uwasa",
    //   tmcCourse: "python-2025"
    // },
    // {
    //   tmcOrganization: "e10129575",
    //   tmcCourse: "ython-perusteet2025"
    // },
    // {
    //   tmcOrganization: "e10129575",
    //   tmcCourse: "python-2025"
    // },
    // {
    //   tmcOrganization: "laurea",
    //   tmcCourse: "python-2024-stenberg"
    // },
    // {
    //   tmcOrganization: "hellu",
    //   tmcCourse: "HelluTTK01"
    // },
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-KYBER24AL"
    // },
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-KYBER24B"
    // },
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-PELI24AL"
    // },
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-PELI24B"
    // },
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-WEB24A"
    // },
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-WEB24B"
    // },
    // {
    //   tmcOrganization: "laurea",
    //   tmcCourse: "python_Grotenfelt_autumn_2024"
    // },
    // {
    //   tmcOrganization: "ksyk",
    //   tmcCourse: "python-2024"
    // },

  ],
}

module.exports = courseSettings
